// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_hq-0";
export var fileCarousel = "_hq-2";
export var removeFileButton = "_hq-1";